import React from 'react';
import classnames from 'classnames';
import { isExistingUser } from '@fenderdigital/streaks-utils';
import { trackFireIcon, SessionData } from '../../utils/session-activity-utils';

const milestoneToModal = ['firstRun', 'firstMilestone', 'secondMilestone', 'goalComplete'];

export const getModalType = (milestones: number): string => milestoneToModal[milestones];

interface StreaksButtonProps {
  createdAt: string;
  isOnFire: boolean;
  milestones: number;
  sessionData: SessionData;
  userID: string;
  showStreaksModal: (modalType: string) => {};
}

const StreaksButton: React.FC<StreaksButtonProps> = ({
  isOnFire = false,
  milestones = 0,
  showStreaksModal,
  createdAt = '',
  sessionData,
  userID,
}) => {
  const handleClick = (): void => {
    const modalType = getModalType(milestones);
    showStreaksModal(modalType);
    trackFireIcon({ sessionData, userID, isOnFire });
  };
  return (
    <div>
      {isExistingUser(createdAt) ? (
        <button
          className="streaks-button dib mr4 bn bg-transparent outline-0 pa0"
          data-id="streaks-button"
          onClick={handleClick}
          style={{
            cursor: 'pointer',
            transition: 'color .3s ease',
          }}
          type="button"
        >
          <i className={classnames('f2', 'icon-flame', { 'mid-gray': !isOnFire, red: isOnFire })} />
        </button>
      ) : null}
    </div>
  );
};

export default StreaksButton;
